import AxiosInstance from '../config/AxiosInstance';

export interface Product {
    id: string;
    sku: string;
    type: number;
    productName: string;
    productGroup: { groupName: string };
    updatedAt: Date;
    isActive: boolean;
}

export interface OrderTemplateDetail {
    productId: string;
    productUOMId?: string;
    lowQty: number;
    medQty: number;
    highQty: number
}

// The server sets companyId; without orderTemplateDetails an update leaves the lines alone.
export interface OrderTemplatePayload {
    companyId?: string;
    locationId: string;
    templateName: string;
    description?: string;
    validFrom?: string | null;
    validTo?: string | null;
    orderTemplateDetails?: OrderTemplateDetail[];
}

const createOrderTemplates = async (payload: OrderTemplatePayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/order-templates', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateOrderTemplates = async (id: string, payload: OrderTemplatePayload) => {
    try {
        const { data } = await AxiosInstance.put('/api/inventory/order-templates/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}



const getListOrderTemplates = async (page: number, limit: number, locationId: string, searchValue: string, isActive?: boolean) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/order-templates', {
            params: {
                page: page,
                limit: limit,
                locationId: locationId,
                searchValue: searchValue,
                isActive: isActive
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListOrderTemplatesForOrder = async (page: number, limit: number, locationId: string, searchValue: string, isActive?: boolean) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/order-templates/get-for-order', {
            params: {
                page: page,
                limit: limit,
                locationId: locationId,
                searchValue: searchValue,
                isActive: isActive
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailOrderTemplates = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/order-templates/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteOrderTemplates = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/inventory/order-templates/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}


export {
    createOrderTemplates,
    updateOrderTemplates,
    getListOrderTemplates,
    getDetailOrderTemplates,
    deleteOrderTemplates,
    getListOrderTemplatesForOrder
}